import { createContext, useEffect, useState } from "react";

const ITEM_TYPES = {
	text: "Text Document",
	pdf: "PDF Document",
	folder: "File Folder",
};

const ROWS = [
	{
		id: 1,
		name: "New Document.txt",
		location: "/aa/bb/cc",
		date: "10/10/2022",
		type: ITEM_TYPES.text,
	},
	{ id: 2, name: "New Folder", location: "/xx/yy/zz", date: "10/10/2022", type: ITEM_TYPES.folder },
	{
		id: 3,
		name: "New Folder 2",
		location: "/abc/def/ghi",
		date: "10/10/2022",
		type: ITEM_TYPES.folder,
	},
	{
		id: 4,
		name: "New Document2.txt",
		location: "aaa/bbb/ccc",
		date: "10/10/2022",
		type: ITEM_TYPES.text,
	},
	{ id: 5, name: "AAAAA.pdf", location: "ww/tt/gg", date: "10/10/2022", type: ITEM_TYPES.pdf },
];

export const COLUMN_NAMES = {
	name: "name",
	location: "location",
	date: "date deleted",
	type: "item type",
};

export const TrashContext = createContext({
	selectedItems: [],
	deletedItems: [],
	searchText: "",
	isSelectedAll: false,
	search: () => {},
	restoreItem: () => {},
	deleteItem: () => {},
	emptyTrash: () => {},
	handleClick: () => {},
	toggleSelectAll: () => {},
});

const TrashProvider = ({ children }) => {
	const [selectedItems, setSelectedItems] = useState([]);
	const [deletedItems, setDeletedItems] = useState(ROWS);
	const [searchText, setSearchText] = useState("");
	const [isSelectedAll, setIsSelectedAll] = useState(false);

	useEffect(() => {
		if (isSelectedAll && selectedItems.length < deletedItems.length) {
			setIsSelectedAll(false);
		}
	}, [selectedItems, isSelectedAll, deletedItems]);

	const search = (text) => {
		setSearchText(text);
	};

	const restoreItem = () => {
		console.log("TODO Restore ");
		// TODO: send restore request ( send "selectedItems" )

		setDeletedItems((oldList) => {
			return oldList.filter((item) => !selectedItems.includes(item.id.toString()));
		});

		setSelectedItems([]);
		setIsSelectedAll(false);
	};

	const deleteItem = () => {
		console.log("TODO Delete ");
		// TODO: send delete request ( send "selectedItems" )

		setDeletedItems((oldList) => {
			return oldList.filter((item) => !selectedItems.includes(item.id.toString()));
		});

		setSelectedItems([]);
		setIsSelectedAll(false);
	};

	const emptyTrash = () => {
		console.log("TODO Empty ");
		// TODO: send empty trash request

		setDeletedItems([]);
		setSelectedItems([]);
		setIsSelectedAll(false);
	};

	const handleClick = (event) => {
		const id = event.target.id.toString();

		const isSelected = selectedItems.indexOf(id) !== -1;

		if (isSelected) {
			setSelectedItems((oldList) => {
				const tempList = [...oldList];
				tempList.splice(oldList.indexOf(id), 1);
				return tempList;
			});
			return;
		}

		setSelectedItems((oldList) => {
			const tempList = [...oldList];
			tempList.push(id);
			return tempList;
		});
	};

	const toggleSelectAll = () => {
		setSelectedItems(() => {
			if (isSelectedAll) {
				return [];
			}
			return deletedItems.map((row) => row.id.toString());
		});

		setIsSelectedAll((initialValue) => !initialValue);
	};

	const value = {
		selectedItems,
		deletedItems,
		searchText,
		isSelectedAll,
		search,
		restoreItem,
		deleteItem,
		emptyTrash,
		handleClick,
		toggleSelectAll,
	};
	return <TrashContext.Provider value={value}>{children}</TrashContext.Provider>;
};

export default TrashProvider;
